import React from 'react';
import { Button, Divider, Typography, Box } from '@mui/material';
import TextFormField from '@components/FormFields/TextFormField/TextFormField.component';
import GoogleIcon from 'icons/Google.icon';
import { GoogleLogin, useGoogleLogin } from '@react-oauth/google';

const RegisterCard = () => {
  return (
    <>
      <Box>
        <Typography variant="h1">Create an account</Typography>
        <Typography variant="h4" sx={{ marginTop: '8px' }}>
          Create an account to start using Interviewer
        </Typography>

        {/* <Button
          fullWidth
          type='button'
          onClick={() => googleLogin()}
          startIcon={<GoogleIcon />}
          sx={{
            marginTop: '32px',
            borderRadius: '12px',
            padding: '18px 48px',
            backgroundColor: '#f2f2f2',
          }}
        >
          Sign up using Google
        </Button> */}

        <Box sx={{
          marginTop: '32px'
        }}>
          <GoogleLogin 
            onSuccess={(response) => {
              console.log(response);
            }}
            onError={() => {
              console.log('Google Login Failed');
            }}
            text='signup_with'
          />
        </Box>
      </Box>

      <Divider>or</Divider>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <TextFormField
          required
          name="firstName"
          label="First Name"
          variant="outlined"
          fullWidth
        />
        <TextFormField
          required
          name="lastName"
          label="Last Name"
          variant="outlined"
          fullWidth
        />
        <TextFormField
          name="userName"
          label="Username"
          variant="outlined"
          fullWidth
        />
        <TextFormField
          required
          name="email"
          label="Email"
          type="email"
          variant="outlined"
          fullWidth
        />
      </Box>
    </>
  );
};

export default RegisterCard;
